import { NavLink, Link } from "react-router-dom";
import { FiChevronsLeft, FiChevronsRight } from "react-icons/fi";
import { ROUTES } from "@/routes/paths";
import { SECTIONS } from "@/config/constants";
import { useExploreStore } from "@/features/explore";
import { getVisibleNav } from "./navItems";

const SECTION_LABEL = {
  [SECTIONS.PK_FASHION]: "PK Fashion",
  [SECTIONS.NA_PRODUCTS]: "NA Products",
  [SECTIONS.BOTH]: "Both",
};

const linkClass = (collapsed) => ({ isActive }) =>
  `flex items-center gap-3 rounded-md px-3 py-2 text-sm transition-colors ${
    collapsed ? "justify-center" : ""
  } ${
    isActive
      ? "bg-primary/10 text-primary font-medium"
      : "text-muted-foreground hover:bg-secondary hover:text-foreground"
  }`;

export function Sidebar({ collapsed, onToggle }) {
  const navItems = getVisibleNav();
  const section = useExploreStore((s) => s.section);
  const resetSection = useExploreStore((s) => s.reset);

  return (
    <aside
      className={`fixed inset-y-0 left-0 z-30 hidden flex-col border-r border-border bg-card md:flex ${
        collapsed ? "w-16" : "w-60"
      }`}
    >
      <div className="flex h-16 items-center justify-between px-4">
        {!collapsed && (
          <Link to={ROUTES.HOME} className="text-lg font-semibold text-foreground">
            CrossBorder
          </Link>
        )}
        <button
          onClick={onToggle}
          aria-label={collapsed ? "Expand sidebar" : "Collapse sidebar"}
          className="rounded-md p-2 text-muted-foreground hover:bg-secondary hover:text-foreground"
        >
          {collapsed ? <FiChevronsRight size={18} /> : <FiChevronsLeft size={18} />}
        </button>
      </div>

      {section && !collapsed && (
        <div className="mx-3 mb-2 rounded-md bg-secondary px-3 py-2">
          <p className="text-xs text-muted-foreground">Exploring</p>
          <div className="flex items-center justify-between gap-2">
            <span className="text-sm font-medium text-foreground">
              {SECTION_LABEL[section] ?? section}
            </span>
            <button
              onClick={resetSection}
              className="text-xs text-primary hover:underline"
            >
              Change
            </button>
          </div>
        </div>
      )}

      <nav className="flex-1 space-y-1 px-3">
        {navItems.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.end}
            title={collapsed ? item.label : undefined}
            className={linkClass(collapsed)}
          >
            <item.icon size={18} />
            {!collapsed && <span>{item.label}</span>}
          </NavLink>
        ))}
      </nav>

    </aside>
  );
}

export default Sidebar;
